import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChildren,
  ViewRef
} from '@angular/core';
import {Item} from '../../models/Item';
import {ItemManagerService} from '../../services/itemManager/item-manager.service';
import {MeasurementService} from '../../services/measurementAdapter/measurement.service';
import {ObjectOptionsComponent} from '../../components/object-options/object-options.component';
import {ConcreteLayerService} from '../../services/concreteLayer/concrete-layer.service';
import {EsBsModalService} from '../../services/bsModalService/bs-modal.service';
import {CookieService} from '../../services/coockieService/coockie.service';
import {UiAdapterService} from '../../services/uiAdapterService/ui-adapter.service';
import {WhiteTooltipDirective} from '../../directives/whiteTooltip/white-tooltip.directive';
import {timer} from "rxjs";
import {ActionLogService} from "@src/app/services/actionLogService/action-log.service";

// declare var jQuery;

@Component({
  selector: 'app-object-properties',
  templateUrl: './object-options.component.html',
  styleUrls: ['./object-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ObjectOptionsComponent21 extends ObjectOptionsComponent implements OnDestroy, OnInit {

  @ViewChildren(WhiteTooltipDirective) tooltips;

  constructor(
    protected itemManagerService: ItemManagerService,
    protected measurementAdapter: MeasurementService,
    protected cd: ChangeDetectorRef,
    protected concreteService: ConcreteLayerService,
    protected modalControl: EsBsModalService,
    protected cookieService: CookieService,
    protected uiAdapterService: UiAdapterService,
    protected actionLogService: ActionLogService
  ) {
    super(itemManagerService, measurementAdapter, cd, concreteService, modalControl, cookieService, uiAdapterService, actionLogService);
  }

  ngOnInit(){
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    this.tooltips.forEach((item: WhiteTooltipDirective) => {
      item.hide();
    });
    this.cd.detach();
  }

  centerOnConcrete() {
    this.concreteService.centerOnConcrete(this.itemElm);
  }

  centerMapAtObj(item) {
    item.centerOnObj();
    this.cd.detectChanges();
  }

  isItemCopied(item:Item){
    return item.config.isCopy
  }

  isItemContainObjectArray(item:Item){
    return item.config.isCopy || this.itemManagerService.getAllItemCopies(item).length > 0 || item.config.getInputProp('__objectArray', 'value');
  }

  ungroupItem(item:Item){
    if (
      confirm(Yiit.t('This operation converts every array item to an individual map object. Would you like to continue?'))
    ) {
      item.getObservable('ungroup').next(true);
      timer(500).subscribe(() => {
        this.itemManagerService.updateSelectedItemsGroup();
      });
    }
  }

  selectParentItem(item:Item){
    const parentId = item.config.getCopyParentId;
    const parentItem = this.itemManagerService.getItemById(parentId);
    this.itemElm.getObservable('highlight_object').next(false);
    this.uiAdapterService.selectedItem$ = parentItem;
    parentItem.getObservable('highlight_object').next(true);

  }

  toggleItemDrag(item: Item) {
    // const self = this;
    const isToolDragged = item.config.getTool() && item.config.getTool().is_draggable;
    clearTimeout(item.timer);
    console.log('toggleItemDrag', isToolDragged);
    if (isToolDragged) {
      // if (!this.uiAdapterService.globalDragEnabled) {

        if (item.drag_enabled) {
          item.drag_enabled = false;
          item.timer = null;
        } else {
          item.drag_enabled = true;
          item.timer = setTimeout(() => {
            item.drag_enabled = false;
            item.timer = null;
            if (!this.cookieService.checkCookie('isDraggableModalShow')) {
              this.modalControl.currentModal = '.items-lock-modal';
              this.modalControl.openModal({backdrop: true, keyboard: false});
            }
            this.itemManagerService.isDragTriggered = true;
            this.itemManagerService.isDragTriggeredChanged = true;
            if (!(this.cd as ViewRef).destroyed) {
              this.cd.detectChanges();
            }
          }, 10000);
          this.cd.detectChanges();
        }
      }
    // } else {
    //   item.drag_enabled = false;
    // }
    // item.is_dragged = !item.is_dragged;
  }

  isDragAllowed(item) {
    return item.config.getTool().is_draggable;
  }
}
